module.exports = {
    gateway: {
        operate: '運営',
        add: '追加',
        edit: '修正',
        del: '削除する',
        restart: '再起動',
        sure: '確定',
        cancel: 'キャンセル',
        attr: {
            name: '名前',
            macAddress: 'Macアドレス',
            status: '状態',
            online: '在线',
            online1: 'オンライン',
            offline: '离线',
            offline1: 'オフライン',
            lastUpdateTime: '更新時間',
            wifiVersion: 'wifiファームウェア版',
            bleVersion: 'Bluetoothファームウェア版',
            subModel: '型番'
        },
        addTip: {
            success: 'ゲートウェイが正常に追加されました',
            exist: 'ゲートウェイはすでに存在します',
            fail: 'ゲートウェイの追加に失敗しました',
            permission: 'ゲートウェイを追加する権限がありません'
        },
        editTip: {
            success: 'ゲートウェイが正常に変更されました',
            exist: '変更されたゲートウェイは存在しません',
            fail: 'ゲートウェイの変更に失敗しました',
            permission: 'ゲートウェイを変更する権限がありません'
        },
        delTip: {
            success: 'ゲートウェイが正常に削除されました',
            exist: '削除されたゲートウェイは存在しません',
            fail: 'ゲートウェイの削除に失敗しました',
            msg: '{name}を削除してもよろしいですか',
            permission: 'ゲートウェイを削除する権限がありません'
        },
        restartTip: {
            success: 'ゲートウェイを再起動しています。後でページを更新して最新のステータスを取得してください',
            fail: 'ゲートウェイの再起動に失敗しました',
            msg: '{name}を再起動してもよろしいですか?'
        },
        validMsg: {
            name: 'ゲートウェイ名を入力してください',
            nameLen: '長さは20文字を超えることはできません',
            mac: 'ゲートウェイのMacアドレスを入力してください',
            macRule: '正しいMacアドレスを入力してください',
            macExist: 'ゲートウェイはすでに存在します',
            macFail: '失敗しました。再入力してください'
        },
        wifiUpgrade: 'wifiファームウェアのアップグレード',
        bleUpgrade: 'Bluetoothファームウェアのアップグレード',
        version: 'ファームウェアバージョン',
        select: '選択してください',
        upgradeValidMsg: {
            id: 'バージョンを選択してください'
        },
        chooseVersion: 'アップグレードする',
        upgradeTip: {
            getVersionfail: 'アップグレードバージョンの取得に失敗しました',
            success: 'ゲートウェイ{mac}：ファームウェアはアップグレード中です。後で操作してください',
            fail: 'ゲートウェイ{mac}：ゲートウェイモデルがファームウェアモデルと一致せず、アップグレードが失敗します',
            currentVersion: 'ゲートウェイ{mac}：ファームウェアがアップグレードされました',
            addFirst: '最初にゲートウェイを選択してください',
            err: 'アップグレードに失敗しました',
            exist: 'ゲートウェイ{mac}：ゲートウェイのモデルを取得できません。アップグレードに失敗しました',
            timeLimit: '頻繁なアップグレード操作を実行しない',
            unexist: 'ゲートウェイ{mac}：ゲートウェイが存在しません',
            offline: 'ゲートウェイ{mac}：ゲートウェイはオフラインであり、アップグレードできません',
            permission: 'アップグレードする権限がありません'
        },
        submiting: '提出中...'
    }
}


// WEBPACK FOOTER //
// ./src/components/common/lang/ja/gateway.js